export const Plus = ({ width = 12, height = 12, fillColor = "#2060EA" }) => {
  const viewBoxSize = `0 00 ${width} ${height}`;
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBoxSize}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.4043 0C6.49131 0 6.53516 0.0449002 6.53516 0.133789V5H11.8604C11.9533 5 11.9999 5.04753 12 5.14258V6.21387C12 6.30911 11.9534 6.35742 11.8604 6.35742H6.53516V11.8662C6.53516 11.9551 6.49131 12 6.4043 12H5.42578C5.33877 12 5.29492 11.9551 5.29492 11.8662V6.35742H0.139648C0.0466252 6.35742 0 6.30911 0 6.21387V5.14258C9.08152e-05 5.04753 0.0467161 5 0.139648 5H5.29492V0.133789C5.29492 0.0449002 5.33877 0 5.42578 0H6.4043Z"
        fill={fillColor}
      />
    </svg>
  );
};
